import { Container } from "@mui/material";
import { Button, Row, Col } from "react-bootstrap";
import { apiRequest } from "../components/Config";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import { useEffect, useContext } from "react";

export default function Rodo() {
  const { id } = useParams();
  const { userData, setUserData } = useContext(UserDataContext);
  const navigate = useNavigate();
  //console.log("userData: ", userData);

  const rodo = async () => {
    try {
      if (userData) {
        const response = await apiRequest("rodo", "POST");
        //console.log("response rodo: ", response);
        if (response.error_msg === 200 && userData.userId === id) {
          navigate("/menu");
        }
      }
    } catch (error) {
      console.error("Błąd:", error);
    }
  };

  /*
  const rodo = async () => {
    try {
      if (userData) {
        const response = await apiRequestHeader("rodo", "POST", null, {
          "x-user-id": id,
        });
        console.log("response rodo: ", response);
        if (response.error_msg === 200 && userData.userId === id) {
          navigate("/menu");
        }
      }
    } catch (error) {
      console.error("Błąd:", error);
    }
  };
  useEffect(() => {
    if (userData === undefined) {
      logout();
    }
  }, [userData]);
*/
  const logout = async () => {
    try {
      await apiRequest("logout", "POST");
      setUserData({
        userId: 0,
        user: "",
        permId: "0",
        fullName: "",
        grpName: "",
        description: "",
        is_active: "0",
        phone: "",
        idGrp: "0",
      });
      navigate("/login");
    } catch (error) {
      console.error("Błąd podczas wylogowywania:", error);
    }
  };
  return (
    <div>
      <Container maxWidth="lg">
        <h4>Klauzula informacyjna – RODO (dla użytkowników aplikacji)</h4>{" "}
        Zgodnie z art. 13 ust. 1 i 2 rozporządzenia Parlamentu Europejskiego i
        Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. (tzw. RODO), informujemy,
        że:
        <p className="p7">1. Administrator danych osobowych</p> Administratorem
        Pani/Pana danych osobowych jest Allworks sp. z o.o., z siedzibą w
        Mikołowie, kontakt: [kontakt@allworks.pl / 48 602 209 858].{" "}
        <p className="p7">2. Cel przetwarzania danych</p> Pani/Pana dane osobowe
        (imię, nazwisko, adres e-mail, numer telefonu, miasto zamieszkania) będą
        przetwarzane w celu: zapewnienia dostępu i korzystania z aplikacji,
        umożliwienia kontaktu w sprawach związanych z działaniem aplikacji,
        prowadzenia ewidencji użytkowników, ewentualnej obsługi zgłoszeń
        technicznych lub spraw organizacyjnych.{" "}
        <p className="p7">3. Podstawa prawna przetwarzania danych</p> Dane
        przetwarzane są na podstawie: art. 6 ust. 1 lit. b RODO (niezbędność do
        wykonania umowy – korzystanie z aplikacji), art. 6 ust. 1 lit. f RODO
        (prawnie uzasadniony interes administratora – np. kontakt z
        użytkownikiem, poprawa funkcjonalności aplikacji).{" "}
        <p className="p7">4. Odbiorcy danych</p>
        Dane osobowe mogą być przekazywane podmiotom przetwarzającym je na
        zlecenie Administratora, np. dostawcom usług IT, wyłącznie w zakresie
        niezbędnym do świadczenia usług.{" "}
        <p className="p7">5. Okres przechowywania danych</p> Dane będą
        przechowywane przez okres korzystania z aplikacji oraz do 3 lat po
        zakończeniu korzystania – w celach dowodowych i archiwizacyjnych, chyba
        że przepisy prawa wymagają dłuższego okresu.{" "}
        <p className="p7">6. Prawa osoby, której dane dotyczą</p> Przysługuje
        Pani/Panu prawo dostępu do danych, ich sprostowania, usunięcia,
        ograniczenia przetwarzania, przeniesienia danych oraz wniesienia
        sprzeciwu. Przysługuje również prawo wniesienia skargi do Prezesa UODO.
        <p className="p7">7. Dobrowolność podania danych</p> Podanie danych
        osobowych jest dobrowolne, ale niezbędne do korzystania z aplikacji.
      </Container>
      <Container>
        <hr />
        <Row>
          <Col md="2">
            <Button variant="primary" type="submit" onClick={rodo}>
              Akceptuję
            </Button>
          </Col>
          <Col>
            <Button variant="light" type="submit" onClick={logout}>
              Odrzucam
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
